class CartReservationTimer extends HTMLElement {
  connectedCallback() {
    const duration = 5 * 60 * 1000;
    const cartCount = this.dataset.cartCount || '0';
    const storageKey = 'alpensohle-cart-reservation';
    let state;

    try {
      state = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
    } catch (_error) {
      state = null;
    }

    if (!state || state.cartCount !== cartCount) {
      state = { cartCount, expiresAt: Date.now() + duration };
      sessionStorage.setItem(storageKey, JSON.stringify(state));
    }

    this.expiresAt = state.expiresAt;
    this.update();
    this.interval = window.setInterval(() => this.update(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.interval);
  }

  update() {
    const remaining = Math.max(0, this.expiresAt - Date.now());
    if (remaining === 0) {
      window.clearInterval(this.interval);
      this.classList.add('is-expired');
      this.style.cssText = 'display:flex;align-items:center;gap:10px;margin:0 24px 8px;padding:12px;border-radius:8px;background:#fee2e2;color:#c62828;font-size:13px;line-height:1.35;';
      this.innerHTML = '<span aria-hidden="true" style="display:grid;width:18px;height:18px;flex:0 0 18px;place-items:center;border-radius:50%;background:#c62828;color:#fff;font-weight:700;">!</span><span>Reservierung abgelaufen – Artikel könnten nicht mehr verfügbar sein</span>';
      return;
    }
    const totalSeconds = Math.floor(remaining / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = String(totalSeconds % 60).padStart(2, '0');
    const output = this.querySelector('[data-reservation-time]');
    if (output) output.textContent = `${minutes}:${seconds}`;
  }
}

if (!customElements.get('cart-reservation-timer')) {
  customElements.define('cart-reservation-timer', CartReservationTimer);
}
